import { defineComponent as p, ref as a, openBlock as e, createElementBlock as n, Fragment as s, renderList as l, createCommentVNode as u } from "vue";
const c = {
  key: 0,
  class: "skeleton"
}, i = {
  key: 1,
  class: "skeleton-box"
}, _ = /* @__PURE__ */ p({
  __name: "IstSkeleton",
  props: {
    skeletonType: {}
  },
  setup(k) {
    const o = a(4);
    return (r, d) => (e(), n("div", null, [
      r.skeletonType === "menu" ? (e(), n("div", c, [
        (e(!0), n(s, null, l(o.value, (t) => (e(), n("div", { key: t }))), 128))
      ])) : u("", !0),
      r.skeletonType === "person-box" ? (e(), n("div", i, [
        (e(!0), n(s, null, l(o.value, (t) => (e(), n("div", { key: t }))), 128))
      ])) : u("", !0)
    ]));
  }
});
export {
  _ as default
};
